export default "__VITE_ASSET__BiEqMCB0__"